/**
 * Auto-generated by graphql-codegen (anonymous-fields-plugin.ts).
 * Do not edit manually.
 *
 * Root-level Query/Mutation/Subscription fields decorated with @allowAnonymous.
 * These fields do not require an account header and are carried over as seed
 * data when switching to a new (unvisited) account snapshot.
 */
export const ANONYMOUS_FIELDS: ReadonlySet<string> = new Set([
]);
